const burgerListEn = [
   {
    name : 'Classic Burger',
    priceSingle : 6.99,
    priceTrio : 10.99,
    ingredients : ['Lettuce', 'Tomato', 'Pickle', 'Onion', ]
  },
   {
    name : 'Steak filet',
    priceSingle : 8.99,
    priceTrio : 12.99,
    ingredients : ['Steak Filet', 'Sauteed pepper', 'Mushrooms', 'Onion', 'Cheese sauce']
  },
   {
    name : 'Chicken filet',
    priceSingle : 8.99,
    priceTrio : 12.99,
    ingredients : ['Chicken Filet', 'Sauteed pepper', 'Mushrooms', 'Onion', 'Cheese sauce']
  },
   {
    name : 'Classic chicken Burger',
    priceSingle : 6.99,
    priceTrio : 10.99,
    ingredients : ['Chicken', 'Lettuce', 'Tomato', 'Pickle', ]
  },
   {
    name : 'chicken Burger',
    priceSingle : 9.99,
    priceTrio : 13.99,
    ingredients : ['Grilled chicken', 'Lettuce', 'Tomato', 'Pickle', 'Onion rings', ]
  },
   {
    name : 'Veggie Burger',
    priceSingle : 7.99,
    priceTrio : 11.99,
    ingredients : ['Fried chickpea', 'Lettuce', 'Tomato', 'Pickle', 'Chickpea sauce']
  },
   {
    name : 'Fried mozzarella Burger',
    priceSingle : 10.99,
    priceTrio : 14.99,
    ingredients : ['Fried mozzarella', 'Lettuce', 'Tomato', 'Pickle', 'BBQ Sauce']
  },
   {
    name : 'Hot cheese Burger',
    priceSingle : 9.99,
    priceTrio : 13.99,
    ingredients : ['Hot cheese', 'Hot sauce', 'Jalapeno', 'Lettuce', 'Tomato', 'Chips', 'Onion']
  },
   {
    name : 'Fumed Burger',
    priceSingle : 9.99,
    priceTrio : 13.99,
    ingredients : ['Fumed cheese', 'Fumed meat', 'Lettuce', 'Tomato', 'Pickle', 'Onion', 'Fumed sauce']
  },
   {
    name : 'Feta Burger',
    priceSingle : 8.99,
    priceTrio : 12.99,
    ingredients : ['Feta cheese', 'Rocket', 'Sautéed mushrooms', 'Caramelized onions', 'Pesto sauce']
  },
   {
    name : 'Planet',
    priceSingle : 6.99,
    priceTrio : 10.99,
    ingredients : ['Cheese sauce', 'Beef bacon', 'Tomato', 'Pickle', 'Onion rings', ]
  },
   {
    name : 'Swiss Burger',
    priceSingle : 8.99,
    priceTrio : 12.99,
    ingredients : ['Swiss cheese', 'Caramelized onions', 'Sautéed mushrooms', 'Rocket', 'Pesto sauce']
  },
   {
    name : 'Chedd egg Burger',
    priceSingle : 10.99,
    priceTrio : 14.99,
    ingredients : ['Cheddar cheese', 'Egg', 'Beef bacon', 'Lettuce', 'Tomato', 'Pickle', 'Onion', ]
  },

]

const burgerListFr = [
  {
   name : 'Classic',
   priceSingle : 6.99,
   priceTrio : 10.99,
   ingredients : ['Laitue', 'Tomate', 'Cornichon', 'Oignon', 'Sauce B12']
 },
  {
   name : 'Filet steak',
   priceSingle : 8.99,
   priceTrio : 12.99,
   ingredients : [' Filet steak', 'Poivron sautés', 'Champignon', 'Oignon', 'Sauce fromage']
 },
  {
   name : 'Filet poulet',
   priceSingle : 8.99,
   priceTrio : 12.99,
   ingredients : ['Filet poulet', 'Poivron sautés', 'Champignon', 'Oignon', 'Sauce fromage']
 },
  {
   name : 'Poulet classic',
   priceSingle : 6.99,
   priceTrio : 10.99,
   ingredients : ['Poulet', 'Laitue', 'Tomate', 'Cornichon', 'Sauce B12']
 },
  {
   name : 'Poulet',
   priceSingle : 9.99,
   priceTrio : 13.99,
   ingredients : ['Poulet grillé', 'Laitue', 'Tomate', 'Cornichon', "Rondelles d'oingons", 'Sauce B12']
 },
  {
   name : 'Veggie',
   priceSingle : 7.99,
   priceTrio : 11.99,
   ingredients : ['Pois chiche frit', 'Laitue', 'Tomate', 'Cornichon', 'Sauce au pois chiche']
 },
  {
   name : 'Mozzarella frit',
   priceSingle : 10.99,
   priceTrio : 14.99,
   ingredients : ['Mozzarella frit', 'Laitue', 'Tomate', 'Cornichon', 'Sauce BBQ']
 },
  {
   name : 'Fromage piquant',
   priceSingle : 9.99,
   priceTrio : 13.99,
   ingredients : ['Fromage piquant', 'Sauce piquante', 'Jalapeno', 'Laitue', 'Tomate', 'Chips', 'Oingon']
 },
  {
   name : 'Fumé',
   priceSingle : 9.99,
   priceTrio : 13.99,
   ingredients : ['Fromage fumé', 'Viande fumée', 'Laitue', 'Tomate', 'Cornichon', 'Oingon', 'Sauce fumée']
 },
  {
   name : 'Feta',
   priceSingle : 8.99,
   priceTrio : 12.99,
   ingredients : ['Fromage feta', 'Roquette', 'Champignon sauté', 'Oingons caramelisés', 'Sauce pesto']
 },
  {
   name : 'Planet',
   priceSingle : 6.99,
   priceTrio : 10.99,
   ingredients : ['Sauce fromage', 'Bacon au boeuf', 'Tomate', 'Cornichon', "Rondelles d'oingons", 'Sauce B12']
 },
  {
   name : 'Suisse',
   priceSingle : 8.99,
   priceTrio : 12.99,
   ingredients : ['Fromage suisse', 'Oingons caramelisés', 'Champignon sauté', 'Roquette', 'Sauce pesto']
 },
  {
   name : 'Oeuf chedd',
   priceSingle : 10.99,
   priceTrio : 14.99,
   ingredients : ['Fromage cheddar', 'Oeuf', 'Bacon au boeuf', 'Laitue', 'Tomate', 'Cornichon', 'Oingon', 'Sauce B12']
 },

]

export {burgerListEn, burgerListFr}